import React from 'react'
import { useSlate } from 'slate-react'

import { CustomElement } from '../types'

import Box from 'components_new/atoms/Box'

import SelectButton from 'components_new/molecules/SelectButton'

import { isBlockActive, toggleBlock } from '../utils'
import { dict } from '../lib'

interface Props {
  defaultOption: CustomElement['type']
  options: CustomElement['type'][]
}

const BlockSelect = (props: Props) => {
  const { defaultOption, options } = props

  const editor = useSlate()
  const activeBlock =
    options.find((format) => isBlockActive(editor, format, 'type')) ||
    defaultOption

  const selectOptions = options.map((option) => ({
    id: option,
    title: dict[option].title
  }))

  return (
    <Box
      onMouseDown={(event) => event.preventDefault()}
      sx={{ display: 'flex' }}
    >
      <SelectButton
        onChange={(value) =>
          toggleBlock(editor, value as CustomElement['type'])
        }
        options={selectOptions}
        value={activeBlock}
      />
    </Box>
  )
}

export default BlockSelect
